const tenantInitialConfig = {
  domain: '',
  drive_folder_pattern: '',
  group_name_pattern: '',
  email_suffix: '',
  email_prefix: '',
};

export default tenantInitialConfig;
